import {ExtendedStatisticsCar} from '../pages/StatisticsPage/components/Chart/types/ExtendedStatisticsCar';

export function isOnStock(car: ExtendedStatisticsCar) {
  return !car.isMyVehicle && car.is_available;
}
